import { Vector } from '../../model/index.js';
import { BitLength } from '../index.js';
import { IntEncoder } from './IntEncoder.js';
import { BooleanEncoder } from './BooleanEncoder.js';
import { FixedVectorEncoder } from './FixedVectorEncoder.js';
import { VectorEncodingType } from './VectorEncodingType.js';
import { DecodingError } from '../../errors/index.js';
export class VendorVectorEncoder {
    static encode(value) {
        /*                            */
        const ranges = [];
        let range = [];
        /*                                                   */
        let retrString = IntEncoder.encode(value.maxId, BitLength.maxId);
        /*                                                               */
        let bitField = '';
        let rangeIsSmaller;
        /*        */
        const headerLength = BitLength.maxId + BitLength.encodingType;
        const bitFieldLength = headerLength + value.maxId;
        const minRangeLength = (BitLength.vendorId * 2 + BitLength.singleOrRange + BitLength.numEntries);
        /*                                        */
        let rangeLength = headerLength + BitLength.numEntries;
        /*                                     */
        value.forEach((curValue, i) => {
            /*                                */
            bitField += BooleanEncoder.encode(curValue);
            /**
 *
 *
 *
 *
 *
 *
 */
            rangeIsSmaller = (value.maxId > minRangeLength && rangeLength < bitFieldLength);
            /**
 *
 *
 *
 *
 *
 */
            if (rangeIsSmaller && curValue) {
                /**
 *
 */
                const nextValue = value.has(i + 1);
                /*                                                         */
                if (!nextValue) {
                    /**
 *
 *
 */
                    range.push(i);
                    /*                                              */
                    rangeLength += BitLength.vendorId;
                    /*                                  */
                    ranges.push(range);
                    /*                                 */
                    range = [];
                }
                else if (range.length === 0) {
                    /*                                      */
                    range.push(i);
                    /*                                       */
                    rangeLength += BitLength.singleOrRange;
                    rangeLength += BitLength.vendorId;
                }
            }
        });
        if (rangeIsSmaller) {
            retrString += String(VectorEncodingType.RANGE);
            retrString += this.buildRangeEncoding(ranges);
        }
        else {
            retrString += String(VectorEncodingType.FIELD);
            retrString += bitField;
        }
        return retrString;
    }
    static decode(value, version) {
        let vector;
        let index = 0;
        const maxId = IntEncoder.decode(value.substr(index, BitLength.maxId), BitLength.maxId);
        index += BitLength.maxId;
        const encodingType = IntEncoder.decode(value.charAt(index), BitLength.encodingType);
        index += BitLength.encodingType;
        /**
 *
 */
        if (encodingType === VectorEncodingType.RANGE) {
            vector = new Vector();
            if (version === 1) {
                if (value.substr(index, 1) === '1') {
                    throw new DecodingError('Unable to decode default consent=1');
                }
                /*                             */
                index++;
            }
            const numEntries = IntEncoder.decode(value.substr(index, BitLength.numEntries), BitLength.numEntries);
            index += BitLength.numEntries;
            /*                                 */
            for (let i = 0; i < numEntries; i++) {
                /*                                                  */
                const isIdRange = BooleanEncoder.decode(value.charAt(index));
                index += BitLength.singleOrRange;
                /**
 *
 *
 */
                const firstId = IntEncoder.decode(value.substr(index, BitLength.vendorId), BitLength.vendorId);
                index += BitLength.vendorId;
                /*                                                     */
                if (isIdRange) {
                    const secondId = IntEncoder.decode(value.substr(index, BitLength.vendorId), BitLength.vendorId);
                    index += BitLength.vendorId;
                    /*                                                                         */
                    for (let j = firstId; j <= secondId; j++) {
                        vector.set(j);
                    }
                }
                else {
                    vector.set(firstId);
                }
            }
        }
        else {
            const bitField = value.substr(index, maxId);
            index += maxId;
            vector = FixedVectorEncoder.decode(bitField, maxId);
        }
        vector.bitLength = index;
        return vector;
    }
    static buildRangeEncoding(ranges) {
        /*                                       */
        const numEntries = ranges.length;
        let rangeString = IntEncoder.encode(numEntries, BitLength.numEntries);
        /*         */
        ranges.forEach((range) => {
            /*                      */
            const single = (range.length === 1);
            /*                                                                   */
            /*                         */
            rangeString += BooleanEncoder.encode(!single);
            /*                                     */
            rangeString += IntEncoder.encode(range[0], BitLength.vendorId);
            if (!single) {
                /*                             */
                rangeString += IntEncoder.encode(range[1], BitLength.vendorId);
            }
        });
        return rangeString;
    }
}
